import axios from "../../utils/axios";

export const getBlogs = async (sort, isSaved) => {
  let query = "";

  if (sort === "newest") {
    query += "_sort=createdAt&_order=desc";
  }
  if (sort === "most_liked") {
    query += "_sort=likes&_order=desc";
  }
  if (isSaved === true) {
    query += "&isSaved=true";
  }

  const response = await axios.get(`/blogs?${query}`);

  return response.data;
};
